<template>
  <b-container fluid>
    <!-- Search Form -->
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('report_management.organization_information_report') }}</h4>
      </template>
      <template v-slot:body>
        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
          <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset">
            <b-row>
              <!-- division -->
              <b-col xl="5" lg="5" md="5" sm="12" xs="12">
                  <ValidationProvider name="Division Id" vid="division_id">
                      <b-form-group
                      class="row"
                      label-cols-sm="2"
                      label-for="division_id"
                      slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                          {{ $t('globalTrans.division') }}
                      </template>
                      <b-form-select
                      v-model="search.division_id"
                      :options="divisionList"
                      id="division_id"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                          <b-form-select-option :value="0" >{{$t('globalTrans.all')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                          {{ errors[0] }}
                      </div>
                      </b-form-group>
                    </ValidationProvider>
                </b-col>

                <!-- district -->
                <b-col xl="5" lg="5" md="5" sm="12" xs="12">
                    <ValidationProvider name="District Id" vid="district_id">
                        <b-form-group
                        class="row"
                        label-cols-sm="2"
                        :label="$t('globalTrans.district')"
                        label-for="district_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{ $t('globalTrans.district') }}
                        </template>
                        <b-form-select
                        v-model="search.district_id"
                        :options="districtList"
                        id="district_id"
                        :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0" >{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <b-col xl="2" lg="2" md="2" sm="12" xs="12">
                  <b-button type="submit" variant="primary">
                    {{ $t('globalTrans.search')}}
                  </b-button>
                </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
      </template>
    </iq-card>
    <!-- /Search Form -->

    <!-- Table/List -->
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('report_management.organization_information_report') }}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <!-- Report Head Data -->
              <b-row v-if="reportHeadData">
                <b-col xs="12" sm="12"  md="12" class="text-right mt-2" v-if="reportData.length > 0">
                   <b-button-group class="pr-2">
                    <b-button @click="pdfExport" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                    <b-button variant="warning">
                      <export-excel
                      worksheet="Report Sheet"
                      :title=excelHeaderValue
                      :fields=excelFields
                      :data=excelData
                        name="organization-list.xls">
                      {{ $t('globalTrans.export_excel') }}
                    </export-excel>
                    </b-button>
                    </b-button-group>
                </b-col>
                <b-col xs="12" sm="12" md="12" class="text-center mt-4">
                  <b-img :src="`${ reportHeadData.reportHeadColumn[2].image }`" fluid alt="BD Image" style="width:7%;border-radius:50%;"></b-img>
                </b-col>
                <b-col xs="12" sm="12" md="3" class="text-right mt-4">
                    <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                </b-col>
                <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                    <h3 class="text-bold">
                        {{ $t('production_store.govt_info') }}
                    </h3>
                    <h4 class="text-center text-dark">
                        {{ reportHeadData.organizationName }}
                    </h4>
                    <span class="text-center text-dark">
                        {{ reportHeadData.heading }}
                    </span><br>
                    <span class="text-center text-dark">
                        {{ reportHeadData.address }}
                    </span><br>
                    <div>
                      <span class="text-center text-dark" style="font-weight:bold;">
                        {{ $t('report_management.organization_information_report') }}
                      </span><br>
                    </div>
                </b-col>
                <b-col xs="12" sm="12" md="3" class="text-left mt-4">
                    <b-img :src="`${ reportHeadData.reportHeadColumn[1].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                </b-col>

                <b-col xs="12" sm="12" md="12" class="mt-4 mb-1">
                  <b-row>
                      <b-col xs="12" sm="12" md="8" class="text-left">
                        <span class="text-center text-dark">{{ $t('globalTrans.division') }}: <b>{{ titleData.division ? (titleData.division) : $t('globalTrans.all') }}</b></span>
                        <span class="text-center text-dark ml-4">{{ $t('globalTrans.district') }}: <b>{{ titleData.district ? (titleData.district) : $t('globalTrans.all') }}</b></span>
                      </b-col>
                  </b-row>
                  <span style="margin-left: 45% !important" v-if="reportData.length === 0">{{ $t('globalTrans.noDataFound') }}</span>
                </b-col>
              </b-row>

              <!-- Data -->
              <b-row>
                <b-col md="12" class="table-responsive">
                  <div v-for="(data, index) in reportData" :key="index">
                    <p style="color: #444;font-size: 18px;margin-bottom: 5px;">{{ $t('globalTrans.district') }}: <b class="ml-1">{{ getDistrictName(data.district_id)}}</b></p>
                    <b-table-simple striped bordered hover>
                      <b-thead>
                        <b-tr>
                          <b-th style="width: 5% !important">{{ $t('globalTrans.sl_no') }}</b-th>
                          <b-th style="width: 40% !important">{{ $t('application_management.registered_organization') }}</b-th>
                          <b-th style="width: 40% !important">{{ $t('performance_monitoring.address') }}</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr v-for="(item, index1) in data.items" :key="index1">
                          <b-td>{{ $n(index1 + 1) }}</b-td>
                          <b-td>{{ $i18n.locale === 'bn' ? item.org_bn : item.org }}</b-td>
                          <b-td>{{ $i18n.locale === 'bn' ? item.address_bn : item.address_en }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-td colspan="3" style="width: 50%">{{ $t('report_management.dis_total_org') }}: <b>{{ $n(data.count) }}</b></b-td>
                        </b-tr>
                        <b-tr v-if="reportData.length-1 === index && search.district_id === 0">
                          <b-td colspan="3" style="width: 50%">{{ $t('report_management.divi_total_org') }}: <b>{{ $n(grand_count) }}</b></b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { organizationInformationReportApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import ExportPdf from './export-pdf'
import ReportHeading from '@/Utils/report-head'
/** Excel */
import excel from 'vue-excel-export'
import Vue from 'vue'
Vue.use(excel)

export default {
  mixins: [ModalBaseMasterList],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      reg_no: 0,
      search: {
        division_id: 0,
        district_id: 0
      },
      titleData: {
        division: '',
        district: '',
        district_id: 0
      },
      orgId: 4,
      editItemId: 0,
      reportData: [],
      amount_of_grant: 0,
      districtList: [],
      reportHeadData: null,
      reportHeadDataLoader: true,
      grand_amount: 0,
      grand_count: 0
    }
  },
  computed: {
    excelHeaderValue: function () {
      const headerVal = []
      if (this.$i18n.locale === 'en') {
        headerVal[0] = this.reportHeadData.orgName
        headerVal[1] = this.reportHeadData.address
        headerVal[2] = this.$t('report_management.organization_information_report')
        headerVal[3] = this.getHeadParam()
        headerVal[4] = ''
      } else {
        headerVal[0] = this.reportHeadData.orgName
        headerVal[1] = this.reportHeadData.address
        headerVal[2] = this.$t('report_management.organization_information_report')
        headerVal[3] = this.getHeadParam()
        headerVal[4] = ''
      }
      return headerVal
    },
    excelFields: function () {
      if (this.$i18n.locale === 'bn') {
            return {
              'জেলা ': 'district',
              'ক্রমিক সংখ্যা': 'serial',
              'সংস্থার নাম': 'org_bn',
              'ঠিকানা ': 'address_bn'
            }
          } else {
            return {
              'District ': 'district',
              'SL No': 'serial',
              'Organization Name': 'org',
              'Address ': 'address_en'
            }
          }
    },
    excelData: function () {
      if (this.reportData.length <= 0) return []
      const excelData = []

      // Primary Loop
      for (let index = 0; index < this.reportData.length; index++) {
        const element = this.reportData[index]
        const district = this.getDistrictName(element.district_id)

        // Secondary Loop
        for (let k = 0; k < element.items.length; k++) {
          const item = element.items[k]
          excelData.push({
            district: district,
            serial: (k + 1),
            org: (this.currentLocale === 'en' ? item.org : item.org_bn),
            address_en: (this.currentLocale === 'en' ? item.address_en : item.address_bn)
          })
        }

        /**
         * From Start to Second Last
         */
        if (index < (this.reportData.length - 1)) {
          excelData.push({
            district: '',
            serial: `<strong> ${this.$t('report_management.dis_total_org')} : ${this.$n(element.count)} </strong>`,
            org: '',
            address_en: ''
          })

          excelData.push({})
        } else {
          /**
           * Last Item for Grand Total
           */
          excelData.push({
            district: '',
            serial: `<strong> ${this.$t('report_management.dis_total_org')} : ${this.$n(element.count)} </strong>`,
            org: '',
            address_en: ''
          })
          if (this.search.district_id === 0) {
            excelData.push({
              district: '',
              serial: `<strong> ${this.$t('report_management.divi_total_org')} : ${this.$n(this.grand_count)} </strong>`,
              org: '',
              address_en: ''
            })
          }
        }
      }

      return excelData
    },
    currentLocale () {
      return this.$i18n.locale
    },
    divisionList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
          { label: this.$t('application_management.registered_organization'), class: 'text-left' },
          { label: this.$t('performance_monitoring.address'), class: 'text-left' }
      ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
          keys = [
              { key: 'index' },
              { key: 'org_bn' },
              { key: 'address_bn' }
          ]
      } else {
          keys = [
          { key: 'index' },
          { key: 'org' },
          { key: 'address_en' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
      })
    }
  },
  created () {
    this.getHeaderData()
    // this.loadData()
  },
  watch: {
    'search.division_id': function (newVal) {
      this.search.district_id = 0
      this.districtList = this.getDistrictList(newVal)
    },
     currentLocale: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getHeaderData()
      }
    }
  },
  methods: {
    getStudent (item) {
      this.reg_no = item.reg_no
    },
    getHeadParam () {
      let tmpText = `${this.$t('globalTrans.division')} : ${this.titleData.division ? this.titleData.division : this.$t('globalTrans.all')}`
      tmpText += `, ${this.$t('globalTrans.district')} : ${this.titleData.district ? this.titleData.district : this.$t('globalTrans.all')}`
      return tmpText
    },
    getDistrictList (divisionId) {
      return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === parseInt(divisionId))
    },
    getDivisionName (divisionId) {
      const obj = this.$store.state.commonObj.divisionList.find(item => item.status === 0 && item.value === parseInt(divisionId))
      if (obj === undefined) {
        return ''
      } else {
        return this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en
      }
    },
    getDistrictName (districtId) {
      const obj = this.$store.state.commonObj.districtList.find(item => item.status === 0 && item.value === parseInt(districtId))
      if (obj === undefined) {
        return ''
      } else {
        return this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en
      }
    },
    searchData () {
      this.loadData()
    },
    view (item) {
      this.editItemId = item.id
    },
    loadData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      const params = Object.assign({}, this.search)
      this.titleData.division = this.getDivisionName(this.search.division_id)
      this.titleData.district = this.getDistrictName(this.search.district_id)
      this.titleData.district_id = this.search.district_id
      this.grand_amount = 0
      this.grand_count = 0

      RestApi.getData(trainingElearningServiceBaseUrl, organizationInformationReportApi, params).then(response => {
        if (response.success) {
            this.reportData = response.data
            this.reportData.forEach(element => {
              this.grand_amount += element.total_amount
              this.grand_count += element.count
            })
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    async getHeaderData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      const headData = await ReportHeading.getReportHead(trainingElearningServiceBaseUrl, 'config/report-heading/detail', this.orgId)
      this.reportHeadData = headData
      this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
    },
    pdfExport () {
      const reportTitle = this.$t('report_management.organization_information_report')
      ExportPdf.exportPdfDetails(trainingElearningServiceBaseUrl, 'config/report-heading/detail', this.orgId, reportTitle, this.reportData, this, this.titleData)
    }
  }
}
</script>
<style scoped>
  .table th, .table td {
    padding: 0 10px !important;
    vertical-align: middle !important;
  }
  .table {
      margin-bottom: 0rem !important;
  }
</style>
